var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pending)?_c('Loader'):_c('Datamatrix',{staticClass:"datamatrix-hoverable",attrs:{"encode-string":_vm.scanCode,"width":_vm.width,"height":_vm.height,"no-tooltip":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }